import GatewayResponse from "entities/gatewayResponse";
import type BackOfficeConnector from "../data/backOfficeConnector";
import type { IPagedResults, IPagination } from "../data/types";
import type EventBus from "../services/eventBus";
import RepositoryBase from "./repositoryBase";
import type { IListRepository } from "./types";
import { serializeFilters } from "utils/filters";
import type SearchGatewaysRequest from "entities/searchGatewaysRequest";

export default class GatewayRepository extends RepositoryBase<BackOfficeConnector> implements IListRepository<GatewayResponse> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  getAll(
    filters: SearchGatewaysRequest,
    pagination: IPagination,
    abortSignal?: AbortSignal
  ): Promise<IPagedResults<GatewayResponse>> {
    return this.callApi(api =>
      api
        .all("enums")
        .all("gateway_search")
        .postPagedEntities({ ...serializeFilters(filters, false), ...pagination }, GatewayResponse, abortSignal)
    );
  }
}
